import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { SessionService }     from './session.service';
import { SharedModule }       from '../shared/shared.module';
import { ValidationsService } from './validations.service';

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    SessionService,
    ValidationsService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class SessionsModule {}
